import { render } from "./UbicationPlayer.vue?vue&type=template&id=042f7921&scoped=true"
import script from "./UbicationPlayer.vue?vue&type=script&lang=js"
export * from "./UbicationPlayer.vue?vue&type=script&lang=js"

import "./UbicationPlayer.vue?vue&type=style&index=0&id=042f7921&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042f7921"]])

export default __exports__